import React from 'react';
import {ReportForm, showErrorNotify, showSuccessNotify} from "../../components";
import {Card, CardContent, Grid} from '@material-ui/core';
import {AutocompleteInput, BooleanInput, DateInput, ReferenceInput, required, Title} from 'react-admin';
import moment from 'moment'
import axiosInstance from "../../api/axios";

class CreateAttendance extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            unitIds: [],
            isLoading: false,
            forceCreate: false,
            fromDate: moment().format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
        };
    }

    generateData = () => {
        this.setState({
            isLoading: true
        });
        axiosInstance.get(`/api/attendance/generateAttendanceResult?fromDate=${this.state.fromDate}&toDate=${this.state.toDate}&forceCreate=${this.state.forceCreate}&eventId=${this.state.eventId}`)
            .then(() => {
                this.setState({
                    isLoading: false
                });
                showSuccessNotify("Tạo dữ liệu thành công")
            }).catch((e) => {
            this.setState({
                isLoading: false
            });
            showErrorNotify("Có lỗi xảy ra. Vui lòng liên hệ quản trị viên!")
        })
    }


    validate = (values) => {
        const errors = {};
        values.eventId = this.state.eventId;
        // Copy input values to params
        this.setState({
            unitIds: values.unitIds,
            forceCreate: values.forceCreate,
            fromDate: values.fromDate,
            toDate: values.toDate,
        });
        return errors;
    }


    onEventChanged(e, value) {
        this.setState({
            eventId: value
        })
    }

    render() {
        return (
            <Card>
                <Title title="resources.create-attendance.name"/>
                <CardContent>
                    <ReportForm params={this.state}
                                validate={this.validate}
                                excelReport={this.generateData}
                                isLoading={this.state.isLoading}
                                label={'Tạo dữ liệu'}
                    >

                        <Grid container>

                            <Grid item xs={12} sm={6}>
                                <DateInput label="resources.common.fromDate"
                                           source="fromDate"
                                           inputProps={{
                                               max: moment().format('YYYY-MM-DD'),
                                           }}
                                           {...this.props}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <DateInput label="resources.common.toDate"
                                           source="toDate"
                                           inputProps={{
                                               max: moment().format('YYYY-MM-DD'),
                                           }}
                                           {...this.props}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <ReferenceInput source="eventId"
                                                reference="events"
                                                label="resources.soDiemDanh.eventId"
                                                perPage={50}
                                                filter={{filterPath: 'filterSimple', type: 'ATTENDANCE'}}
                                                validate={required()}
                                                onChange={(e, value) => this.onEventChanged(e, value)}
                                >
                                    <AutocompleteInput fullWidth source="name"
                                                       optionText={(e) => `${e.name} - ${e.eventTime}`}/>
                                </ReferenceInput>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <BooleanInput source="forceCreate" label={'Tạo lại'} {...this.props} />
                            </Grid>
                            <Grid item xs={12}>
                                <p style={{color: 'red', fontSize: 12, fontStyle: 'italic'}}>
                                    * Lưu ý: nếu chọn Tạo lại dữ liệu sẽ được
                                    xoá và tạo lại,
                                    cần thực hiện duyệt lại sự kiện nếu có nhu cầu
                                </p>
                                <p style={{color: 'red', fontSize: 12, fontStyle: 'italic'}}>
                                    * Nếu không chọn tạo lại dữ liệu sẽ chỉ cập nhật những lớp/phòng ban chưa được duyệt
                                </p>
                            </Grid>
                        </Grid>
                    </ReportForm>
                </CardContent>
            </Card>
        )
    }
}

export default CreateAttendance;
